import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import firebase from '@firebase/app-compat';
import { take } from 'rxjs/operators';
import { MailService } from '../mail/mail.service';
import { UserProfileService } from '../user-profile/user-profile.service';

import OneSignal from 'onesignal-cordova-plugin';
import { LoginService } from '../login/login.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

interface Driver {
  userID: string;
  playerID?: string;
}

interface CallAgent {
  userID: string;
  playerID?: string;
}

@Injectable({
  providedIn: 'root',
})
export class OrderService {
  constructor(
    private firestore: AngularFirestore,
    private mailService: MailService,
    private userProfileService: UserProfileService,
    private loginService: LoginService,
    private httpClient: HttpClient
  ) {}

  placeOrder(order) {
    const db = firebase.firestore();
    const userRef = db.collection('Sequence').doc('TbYbX55oPzlYkSBX4pS3');
    const increment = firebase.firestore.FieldValue.increment(1);
    return userRef.update({ value: increment }).then(() =>
      this.firestore
        .collection('Sequence')
        .doc('TbYbX55oPzlYkSBX4pS3')
        .get()
        .subscribe((res: any) => {
          const data = res.data();
          const invoice = data.value;
          const id = this.firestore.createId();
          const time = firebase.firestore.FieldValue.serverTimestamp();
          return this.firestore
            .collection('Orders')
            .doc(id)
            .set({
              ...order,
              invoice,
              createdAt: time,
            });
        })
    );
  }

  makeRequest(order) {
    let status;
    const { paymentMethod } = order;
    if (paymentMethod.toLowerCase() === 'cash') {
      status = 'pay-on-delivery';
    } else if (paymentMethod.toLowerCase() === 'wallet') {
      status = 'awaiting-payment';
    } else if (paymentMethod.toLowerCase() === 'card-payment') {
      status = 'awaiting-payment';
    }

    const db = firebase.firestore();
    const userRef = db.collection('Sequence').doc('TbYbX55oPzlYkSBX4pS3');
    const increment = firebase.firestore.FieldValue.increment(1);
    return userRef.update({ value: increment }).then(() =>
      this.firestore
        .collection('Sequence')
        .doc('TbYbX55oPzlYkSBX4pS3')
        .get()
        .pipe(take(1))
        .subscribe((res: any) => {
          const data = res.data();
          const invoice = data.value;
          const id = this.firestore.createId();
          const time = firebase.firestore.FieldValue.serverTimestamp();
          return this.firestore
            .collection('Orders')
            .doc(id)
            .set({
              ...order,
              invoice,
              createdAt: time,
              status,
              requestRejectedBy: '',
              requestAcceptedBy: '',
              orderType: 'app-order',
            })
            .then(() => {
              const message = 'Delivery Request';
              this.sendDriversNotification(message);
              this.sendAgentsNotification(message);
            });
        })
    );
  }

  getOrders() {
    return this.firestore
      .collection('Orders', (ref) => ref.orderBy('createdAt', 'desc').limit(20))
      .snapshotChanges();
  }

  getDriverAssignedOrders(driverID) {
    return this.firestore
      .collection('Orders', (ref) =>
        ref

          .orderBy('createdAt', 'desc')
          .where('assignedDriver', '==', driverID)
          .limit(20)
      )
      .snapshotChanges();
  }

  getUserOrders(userID) {
    return this.firestore
      .collection('Orders', (ref) =>
        ref
          .orderBy('createdAt', 'desc')
          .where('requestBy', '==', userID)
          .limit(20)
      )
      .snapshotChanges();
  }

  getOrderByInvoice(invoice) {
    return this.firestore
      .collection('Orders', (ref) => ref.where('invoice', '==', invoice))
      .get();
  }

  updateOrder(docID, payMethod) {
    if (payMethod.toLowerCase() === 'cash') {
      return this.firestore.collection('Orders').doc(docID).update({
        status: 'pay-on-delivery',
        paymentMethod: payMethod,
      });
    } else {
      return this.firestore.collection('Orders').doc(docID).update({
        status: 'payment-made',
        paymentMethod: payMethod,
      });
    }
  }

  driverAcceptRequest(docID, driverID, order) {
    // const {
    //   createdAt,
    //   deliveryFee,
    //   email,
    //   invoice,
    //   name,
    //   paymentMethod,
    //   phone,
    //   requestAcceptedBy,
    //   requestBy,
    //   requestRejectedBy,
    //   requestType,
    //   status,
    // } = order;

    return this.firestore
      .collection('Orders')
      .doc(docID)
      .update({
        status: 'request-accepted',
        requestAcceptedBy: driverID,
      })
      .then(() => {
        this.mailService.sendAcceptance(order).pipe(take(1));
      });
  }

  driverRejectRequest(docID, driverID, order) {
    const {
      createdAt,
      deliveryFee,
      email,
      invoice,
      name,
      paymentMethod,
      phone,
      requestAcceptedBy,
      requestBy,
      requestRejectedBy,
      requestType,
      status,
    } = order;

    return this.firestore
      .collection('Orders')
      .doc(docID)
      .update({
        status: 'rejected',
        requestRejectedBy: driverID,
        requestAcceptedBy: '',
      })
      .then(() => {
        if (
          paymentMethod.toLowerCase() === 'wallet' &&
          status === 'payment-made'
        ) {
          this.userProfileService
            .uploadWallet(requestBy, deliveryFee)
            .then(() => {
              this.mailService.sendRejection(order).pipe(take(1));
            });
        } else {
          this.mailService.sendRejection(order).pipe(take(1));
        }
      });
  }

  completeDelOrder(docID) {
    // const {
    //   createdAt,
    //   deliveryFee,
    //   email,
    //   invoice,
    //   name,
    //   paymentMethod,
    //   phone,
    //   requestAcceptedBy,
    //   requestBy,
    //   requestRejectedBy,
    //   requestType,
    //   status,
    // } = order;
    const time = firebase.firestore.FieldValue.serverTimestamp();
    return this.firestore
      .collection('Orders')
      .doc(docID)
      .update({
        status: 'delivered',
        completedAt: time,
      })
      .then(() => {
        // this.mailService.sendCompletion(order).pipe(take(1));
      });
  }

  getDriverOrders(driverID) {
    return this.firestore
      .collection('Orders', (ref) =>
        ref.where('requestAcceptedBy', '==', driverID)
      )
      .snapshotChanges();
  }

  sendDriversNotification(message) {
    this.loginService
      .getDriversPlayerIDs()
      .pipe(take(1))
      .subscribe((driversRes) => {
        const playerIDs = [];
        const externalIDs = [];

        driversRes.docs.map((driver) => {
          const driverData = driver.data() as Driver;

          // if (driverData.hasOwnProperty('playerID')) {
          // }

          playerIDs.push(driverData.playerID);
          externalIDs.push(driverData.userID);
        });

        const notificationObj = {
          contents: {
            en: message,
          },
          // eslint-disable-next-line @typescript-eslint/naming-convention
          app_id: environment.oneSignalKey,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          //external_user_ids: externalIDs,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          include_player_ids: playerIDs,
          data: {
            type: 'user-delivery-request',
          },
        };

        // OneSignal.postNotification(
        //   JSON.stringify(notificationObj),
        //   (results) => {
        //     console.log(results);
        //     alert(JSON.stringify(results));
        //   }
        // );

        const url = 'https://onesignal.com/api/v1/notifications';

        const headers = {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'Content-Type': 'application/json; charset=utf-8',
        };

        const options = {
          host: 'onesignal.com',
          port: 443,
          path: '/api/v1/notifications',
          method: 'POST',
          headers,
        };

        this.httpClient
          .post(url, notificationObj, options)
          .pipe(take(1))
          .subscribe((data) => {
            // console.log(data);
          });
      });
  }

  sendAgentsNotification(message) {
    this.loginService
      .getAgentsPlayerIDs()
      .pipe(take(1))
      .subscribe((res) => {
        const playerIDs = [];
        const externalIDs = [];

        res.docs.map((agent) => {
          const driverData = agent.data() as CallAgent;

          // if (driverData.hasOwnProperty('playerID')) {
          // }

          playerIDs.push(driverData.playerID);
          externalIDs.push(driverData.userID);
        });

        const notificationObj = {
          contents: {
            en: message,
          },
          // eslint-disable-next-line @typescript-eslint/naming-convention
          app_id: environment.oneSignalKey,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          //external_user_ids: externalIDs,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          include_player_ids: playerIDs,
          data: {
            type: 'user-delivery-request',
          },
        };

        // OneSignal.postNotification(
        //   JSON.stringify(notificationObj),
        //   (results) => {
        //     console.log(results);
        //     alert(JSON.stringify(results));
        //   }
        // );

        const url = 'https://onesignal.com/api/v1/notifications';

        const headers = {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'Content-Type': 'application/json; charset=utf-8',
        };

        const options = {
          host: 'onesignal.com',
          port: 443,
          path: '/api/v1/notifications',
          method: 'POST',
          headers,
        };

        this.httpClient
          .post(url, notificationObj, options)
          .pipe(take(1))
          .subscribe((data) => {
            // console.log(data);
          });
      });
  }

  assignOrderDriver(docID, driverID) {
    return this.firestore.collection('Orders').doc(docID).update({
      assignedDriver: driverID,
    });
  }

  sendDriverNotification(driverID, message) {
    this.loginService
      .getDriverPlayerID(driverID)
      .pipe(take(1))
      .subscribe((driverRes) => {
        const playerIDs = [];
        const externalIDs = [];

        const driverData = driverRes.data() as Driver;

        playerIDs.push(driverData.playerID);
        externalIDs.push(driverData.userID);

        const notificationObj = {
          contents: {
            en: message,
          },
          // eslint-disable-next-line @typescript-eslint/naming-convention
          app_id: environment.oneSignalKey,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          //external_user_ids: externalIDs,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          include_player_ids: playerIDs,
          data: {
            type: 'user-delivery-request',
          },
        };

        const url = 'https://onesignal.com/api/v1/notifications';

        const headers = {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'Content-Type': 'application/json; charset=utf-8',
        };

        const options = {
          host: 'onesignal.com',
          port: 443,
          path: '/api/v1/notifications',
          method: 'POST',
          headers,
        };

        this.httpClient
          .post(url, notificationObj, options)
          .pipe(take(1))
          .subscribe((data) => {
            // console.log(data);
          });
      });
  }

  getStorePoints() {
    return this.firestore.collection('Store-Points').snapshotChanges();
  }

  getStoreCoords(docID) {
    return this.firestore
      .collection(`Store-Points/${docID}/coords`)
      .doc('coords')
      .snapshotChanges();
  }

  // DELIVERY FEES
  getDeliveryFees() {
    return this.firestore.collection('DeliveryFees').doc('Fees').get();
  }
}
